// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"ee4501a7","977":"b932c3f5"}[chunkId] + ".chunk.js");